import { render, staticRenderFns } from "./SpiceLevel.vue?vue&type=template&id=a2c9722c&"
import script from "./SpiceLevel.vue?vue&type=script&lang=js&"
export * from "./SpiceLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports